<template>

  <svg
    t="1631088937148"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4794"
    width="64"
    height="64"
  ><path d="M512 2.27555555a509.72444445 509.72444445 0 1 0 509.72444445 509.72444445A509.72444445 509.72444445 0 0 0 512 2.27555555z m368.36693333 275.2512L548.40888889 469.31057778V76.73173333a436.90666667 436.90666667 0 0 1 331.95804444 200.79502222zM512 948.90666667a436.90666667 436.90666667 0 0 1-36.40888889-872.17493334v476.59235556h72.0896l366.54648889-211.71768889A436.90666667 436.90666667 0 0 1 512 948.90666667z" p-id="4795" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconChartPie',
} as DefineComponent
</script>